<div class="welcome-message">
    <h1>Welcome back, {{name}}</h1>
    <h1>Click the menu on the left to get started.</h1>
</div>